"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * @module ol/style/IconOrigin
 */

/**
 * Icon origin. One of 'bottom-left', 'bottom-right', 'top-left', 'top-right'.
 * @enum {string}
 */
var _default = {
  /**
   * Origin is at bottom left
   * @api
   */
  BOTTOM_LEFT: 'bottom-left',

  /**
   * Origin is at bottom right
   * @api
   */
  BOTTOM_RIGHT: 'bottom-right',

  /**
   * Origin is at top left
   * @api
   */
  TOP_LEFT: 'top-left',

  /**
   * Origin is at top right
   * @api
   */
  TOP_RIGHT: 'top-right'
};
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O0FBSUE7Ozs7ZUFJZTtFQUNiOzs7O0VBSUFBLFdBQVcsRUFBRSxhQUxBOztFQU1iOzs7O0VBSUFDLFlBQVksRUFBRSxjQVZEOztFQVdiOzs7O0VBSUFDLFFBQVEsRUFBRSxVQWZHOztFQWdCYjs7OztFQUlBQyxTQUFTLEVBQUU7QUFwQkUsQyIsIm5hbWVzIjpbIkJPVFRPTV9MRUZUIiwiQk9UVE9NX1JJR0hUIiwiVE9QX0xFRlQiLCJUT1BfUklHSFQiXSwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL3N0eWxlL0ljb25PcmlnaW4uanMiXSwic291cmNlc0NvbnRlbnQiOltudWxsXX0=